
import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';

import { InvoicePayment } from '../../../shared/models/invoicePayment.model';
import { WorkOrderPayment } from './../../../shared/models/worOrderPayment.model';
import { Spending } from './../../../shared/models/spending.model';


@Component({
  selector: 'app-update-work-order-payment-widget',
  templateUrl: './update-work-order-payment-widget.component.html',
  styleUrls: ['./update-work-order-payment-widget.component.scss']
})
export class UpdateWorkOrderPaymentWidgetComponent implements OnInit {

  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;

  @Input() is_create_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() is_update_invoice_item =  false; // false by defualt... now make the component work for both invoices and stand alone.
  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.

  @Input() payment_id?; // impliments on changes.

  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent ;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter(); // simple close window
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
  @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();

  @Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();
  
  @Output('refreshSujectWorkOrderPage') refreshSujectWorkOrderPage: EventEmitter<any> = new EventEmitter();
     // access the template form
     @ViewChild('invoicePaymentForm') invoicePaymentForm: NgForm;

  job: Object;
  billing_tasks: Object;
  model: SubjectBillingItem;

  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  job_type: Object;
  job_type_name: any;
  job_type_id: any;
  job_type_location: Object;
  job_type_location_name: any;
  job_type_court: Object;
  job_type_court_name: any;
  new_subject_billing_item_id: any;
  returned_subject_billing_item_id: any;
  new_invoice_item_id: any;
  returned_invoice_item_id: any;
  invoiceItemsList: any = [];
  invoiceItemsList2: SubjectInvoiceItem;

  paymentModel: Payment = new Payment(); // sets up the model correctly on create.
  invoicePaymentModel: InvoicePayment = new InvoicePayment(); // sets up the model correctly on create.

  invoice_item_model: any = SubjectInvoiceItem;
  myob_account_codes: any;
  myob_tax_codes: Object;
  invoiceItem: Object;
  invoice_model: any;
  invoice_total: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  new_payment_id: any;
  returned_payment_id: any;
  invoice_update_payment_model: any = [];
  workOrderPaymentModel: WorkOrderPayment;
  workOrderItem: any;
  work_order_total: any;
  work_order_model: any;
  spendingModel: Spending;

  returned_spending_id: any;
  new_spending_id: any;
  work_order_update_spending_model: any = [];
  assignedBrandList: Object;
  invoice_payment_status: any;
  brand_id: any;
  spending: any;
  spending_data: any;

  @Input() spending_id?;

  work_order_payment: any;


 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
 ) {

 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


  }

  // check for changes. to load data.
  ngOnChanges(changes) {

this.getSpending(this.spending_id);
this.getWorkOrderSpendingsBySpendingID(this.spending_id);

//this.paymentModel = new Payment();  // starts a new empty payment model
// this.invoicePaymentModel = new InvoicePayment();  // starts a new empty payment model
// this.getSpending(this.spending_id);
this.spendingModel = new Spending();  // starts a new empty payment model
this.workOrderPaymentModel = new WorkOrderPayment();  // starts a new empty payment model



    this.getWorkOrder(this.work_order_id);
    this.getMyobAccountCodes();
 

    this.spendingModel.spending_total = 0; // set to zero as to prevent NaN errors.
    this.workOrderPaymentModel.subject_number = this.subject_number;
    this.workOrderPaymentModel.job_number = this.job_number;

   if (changes.invoice_id) {
     // deal with asynchronous Observable result
    // this.invoice_id = changes.invoice_id.currentValue;
    // this.getInvoice(this.invoice_id);
    // this.getMyobAccountCodes();

   }
 }


 ngOnInit() {
  // this.getInvoice(this.invoice_id);
  // this.getMyobAccountCodes();

  this.spendingModel = new Spending();  // starts a new empty payment model
this.workOrderPaymentModel = new WorkOrderPayment();  // starts a new empty payment model

  this.getSpending(this.spending_id);
  this.getWorkOrderSpendingsBySpendingID(this.spending_id);
  

 }

 // Functions


 getSpending(spending_id) {
  this._demoService.getSpending(spending_id).subscribe(
    (data) => {
      this.spending = data;
      this.spending_data = this.spending;
      this.getWorkOrderSpendingsBySpendingID(spending_id);
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}


getWorkOrderSpendingsBySpendingID(spending_id){
  this._demoService.getWorkOrderSpendingsBySpendingID(spending_id).subscribe(
    (data) => {
      this.work_order_payment = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

 createSubjectSpending(model){
   // :: do the magic here from the form.input model
   this._demoService.createSpending(model).subscribe(
    (data) => {
      this.new_spending_id = data;
      //  let res = data[0];
    this.returned_spending_id = this.new_spending_id.last_insert_id;
  //  console.log('spending id: ' + this.returned_spending_id);
      // now insert the invoice spending record.
      // in this case a payment is a spending item...
      this.createSubjectWorkOrderPayment(model, this.returned_spending_id);
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
  // try here as payment id as not inserting in the subscription

}


  
 createSubjectInvoicePayment(model,  spending_id) {
  // :: do the magic here from the form.input model
  let sent_model = model;
  this._demoService.createSubjectInvoicePayment(model, spending_id).subscribe(
   (data) => {
   //  this.new_payment_id = data;
     //  let res = data[0];
// we now need to update the invoice record with
let payment_status = 2;
let work_order_status = 5;
// partially paid - not allowed yet
if (sent_model.remaining_total > 0){
payment_status = 3; // partially paid
work_order_status = 4; // approved PDF
}
// if fully paid or more.
if (sent_model.remaining_total < 0){
  payment_status = 2; // fully paid
  work_order_status = 5; // closed
  }

this.work_order_update_spending_model = {
  work_order_id: this.work_order_id,
  work_order_payment_total: model.spending_total,
  work_order_remaining_total: model.remaining_total,
  work_order_status_id: work_order_status, // closed
  work_order_payment_status_id: payment_status, // fully paid
  updated_by: this.sessionUserId,
};

this.updateWorkOrderAfterPaymentFigures(this.work_order_update_spending_model);
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}




createSubjectWorkOrderPayment(model, spending_id) {
  // :: do the magic here from the form.input model
  let sent_model = model;
  this._demoService.createSubjectWorkOrderPayment(model, spending_id).subscribe(
   (data) => {
   //  this.new_payment_id = data;
     //  let res = data[0];
// we now need to update the work_order record with
let payment_status = 2;
let work_order_status = 5;
// partially paid - not allowed yet
if (sent_model.remaining_total > 0){
payment_status = 3; // partially paid
work_order_status = 4; // approved PDF
}
// if fully paid or more.
if (sent_model.remaining_total < 0){
  payment_status = 2; // fully paid
  work_order_status = 5; // closed
  }

this.work_order_update_spending_model = {
  work_order_id: this.work_order_id,
  work_order_payment_total: model.payment_total,
  work_order_remaining_total: model.remaining_total,
  work_order_status_id: work_order_status, // closed
  work_order_payment_status_id: payment_status, // fully paid
  updated_by: this.sessionUserId,
};

this.updateWorkOrderAfterPaymentFigures(this.work_order_update_spending_model);
},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}


updateSubjectSpending(model){
  this._demoService.updateSpending(model).subscribe(
    (data) => {
     // this.new_payment_id = data;
     let res = data[0];
this.toastr.success('Payment/Spending details updated');
// :: TOD refresh the invoice modal below.
// this.updateSubjectWorkOrderPayment(model, model.spending_id)

// // Commented all out so that loaded correctly below.
//       this.closeParentModel3.emit();
//       this.closeParentModel2.emit();
//       this.closeParentModel.emit();
//       // this.refreshWorkOrderItemsBelow.emit();
//       this.refreshSujectWorkOrderPage.emit(this.subject_id);

this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);

},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}


// was totally wrong with sending spenign id as the work order_poayment id!!!!
updateSubjectWorkOrderPayment(model, work_order_payment_id) {
  // :: do the magic here from the form.input model
  let sent_model = model;
  this._demoService.updateSubjectWorkOrderPayment(model, work_order_payment_id).subscribe(
   (data) => {

    this.toastr.success('updated agent invoice payment details.')
    this.updateSubjectSpending(model);

   //  this.new_payment_id = data;
     //  let res = data[0];
// // we now need to update the work_order record with
// let payment_status = 2;
// let work_order_status = 5;
// // partially paid - not allowed yet
// if (sent_model.remaining_total > 0){
// payment_status = 3; // partially paid
// work_order_status = 4; // approved PDF
// }
// // if fully paid or more.
// if (sent_model.remaining_total < 0){
//   payment_status = 2; // fully paid
//   work_order_status = 5; // closed
//   }

// Look Up from datbase fill the 

// this.work_order_update_spending_model = {
//   work_order_id: this.work_order_id,
//   work_order_payment_total: model.payment_total,
//   work_order_remaining_total: model.remaining_total,
//   work_order_status_id: work_order_status, // closed
//   work_order_payment_status_id: payment_status, // fully paid
//   updated_by: this.sessionUserId,
// };

// this.updateWorkOrderAfterPaymentFigures(this.work_order_update_spending_model);


},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}

updateWorkOrderAfterPaymentFigures(model){
  this._demoService.updateWorkOrderAfterPaymentFigures(model).subscribe(
    (data) => {
     // this.new_payment_id = data;
     let res = data[0];
this.toastr.success('Payment/Spending + Work Order Record(s) Applied');
// :: TOD refresh the invoice modal below.


// Commented all out so that loaded correctly below.
      // this.closeParentModel3.emit();
      // this.closeParentModel2.emit();
      // this.closeParentModel.emit();
      // this.refreshWorkOrderItemsBelow.emit();
      // this.refreshSujectWorkOrderPage.emit(this.subject_id);


},
(err) => console.error(err),
// () => console.log('Brand Loaded.')
);
}


 getInvoice(invoice_id){
  this._demoService.getSubjectInvoice(invoice_id).subscribe(
    (data) => {
      this.invoiceItem = data;
      let res = data[0];
      this.invoice_number = res.invoice_number;
      this.invoice_total = res.total;
     this.invoice_model = this.invoiceItem;

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.paymentModel.subject_number = res.subject_number;
     this.paymentModel.job_number = res.job_number;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}




getWorkOrderByWorkOrderNumber(invoice_number){
  this._demoService.getSubjectWorkOrderByWorkOrderNumber(invoice_number).subscribe(
    (data) => {
      this.workOrderItem = data;
      let res = data[0];
      this.work_order_number = res.invoice_number;
      this.work_order_total = res.total;
     this.work_order_model = this.workOrderItem;
    //  this.work_order_spending_status = res.invoice_payment_status_id;

     // make the form invalid if invoice not paid.
     // overpay
// if (res.invoice_payment_status_id != 2){
//   // this.toastr.warning('Invoice payment still pending!');
// // set the form to invalid for entry
// this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
//   }

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.spendingModel.subject_number = res.subject_number;
     this.spendingModel.job_number = res.job_number;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}





getInvoiceByInvoiceNumber(invoice_number){
  this._demoService.getSubjectInvoiceByInvoiceNumber(invoice_number).subscribe(
    (data) => {
      this.invoiceItem = data;
      let res = data[0];
      this.invoice_number = res.invoice_number;
      this.invoice_total = res.total;
     this.invoice_model = this.invoiceItem;
     this.invoice_payment_status = res.invoice_payment_status_id;

     // make the form invalid if invoice not paid.
     // overpay
if (res.invoice_payment_status_id != 2){
  // this.toastr.warning('Invoice payment still pending!');
// set the form to invalid for entry
this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
  }

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.paymentModel.subject_number = res.subject_number;
     this.paymentModel.job_number = res.job_number;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getWorkOrder(work_order_id){
  this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
    (data) => {
      this.workOrderItem = data;
      let res = data[0];
      this.work_order_number = res.work_order_number;
      this.work_order_total = res.total;
     this.work_order_model = this.workOrderItem;

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.paymentModel.subject_number = res.subject_number;
     this.paymentModel.job_number = res.job_number;

     // :: INVOICE CHECK - see if there is a recourd or an invoice an if paid!
    //  this.getInvoiceByInvoiceNumber(res.work_order_number);
     this.getWorkOrderByWorkOrderNumber(res.work_order_number);

     this.brand_id = res.agent_id; // work orders have an agent id.

    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


   
 getInvoiceItmes(invoice_id){
  this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];

      this.invoice_item_model = this.invoiceItemsList;

    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
};


 getMyobAccountCodes() {
  this._demoService.getMyobAccountCodes().subscribe(
     data => { this.myob_account_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getMyobTaxCodes() {
  this._demoService.getMyobTaxCodes().subscribe(
     data => { this.myob_tax_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 calculateTotalRemaining(){
   // uses form values using form ngForms
  this.workOrderPaymentModel.remaining_total =
  this.invoicePaymentForm.controls['work_order_total'].value - this.invoicePaymentForm.controls['spending_total'].value;
  this.invoicePaymentForm.controls['remaining_total'].setValue( this.workOrderPaymentModel.remaining_total);

let remaining =  this.workOrderPaymentModel.remaining_total;
// perfect pay
if (remaining == 0){
this.toastr.success('Perfect... You may apply the payment as money spent.');
}

// overpay
if (remaining < 0){
  this.toastr.warning('Over Payment of Work Order Alert!');
// set the form to invalid for entry
this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
  }
// underpay
  if (remaining > 0){
    this.toastr.error('The Value Paid is less than the work order amount?');
    this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
    }


}




getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];
     // Run the job data queries.
     this.job_type_id = res.job_type_id;
         // naming
    this.getJobType(res.job_type_id);
    this.getJobTypeLocation(res.job_type_location_id);
    this.getJobTypeCourt(res.job_type_court_id);
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
};


 // File Nameing
 getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { this.job_type = data;
      let res = data[0];
      this.job_type_name = res.job_type_name;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeLocation(job_type_location_id){
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
    data => { this.job_type_location = data;
   let res = data[0];
   this.job_type_location_name = res.job_type_location_name;

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


 getJobTypeCourt(job_type_court_id){
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
    data => {  this.job_type_court = data;
      let res = data[0];
      this.job_type_court_name = res.job_type_court_name;
     },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }



getBillingTasks() {
  this._demoService.getBillingTasks().subscribe(
     data => { this.billing_tasks = data;
      let res = data[0];
      // Run the job data queries.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getAndSetBillingTask(billing_task_id) {
  this._demoService.getBillingTask(billing_task_id).subscribe(
     data => { this.billing_tasks = data;
      let res = data[0];
      // create insert model
  this.model = {
    subject_id: this.subject_id,
    job_id: this.job_id,
    billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
     + ' ' + this.job_type_court_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_description: res.billing_task_description,
billing_task_fee: res.billing_task_fee,
billing_task_id: res.billing_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
brand_id: this.brand_id
  };

  this.addSubjectBillingItem(this.model);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 addSubjectBillingItem(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Billing Item Added');
      this.refreshParentGrid.emit();
      this.closeParentModel.emit();
      this.refreshSujectInvoicePage.emit(this.subject_id); // so refresh entire page instead.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getAndSetBillingTaskFromInvoice(billing_task_id) {
  this._demoService.getBillingTask(billing_task_id).subscribe(
     data => { this.billing_tasks = data;
      let res = data[0];
      // create insert model
  this.model = {
    subject_id: this.subject_id,
    job_id: this.job_id,
    billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
     + ' ' + this.job_type_court_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_description: res.billing_task_description,
billing_task_fee: res.billing_task_fee,
billing_task_id: res.billing_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
brand_id: this.brand_id,
  };

  this.addSubjectBillingItemFromInvoice(this.model);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 addSubjectBillingItemFromInvoice(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { // this.billing_tasks = data;
     // let res = data[0];
      // Run the job data queries.
      this.toastr.success('Billing Item Added');
      

      // :: TODO!!!!
      // :: Need to refresh the invoice_items_list in parent module??
      
      // :: now hide the invoice modal;
      this.closeParentModel2.emit(null);
      this.refreshParentGrid.emit(); // did not work?
     this.refreshSujectInvoicePage.emit(this.subject_id); // so refresh entire page instead.

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


//  refreshSujectInvoicePage(subject_id){
//   this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
//                 this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));

// }







getAndSetBillingTaskFromInvoiceUpdate(billing_task_id) {

  this._demoService.getBillingTask(billing_task_id).subscribe(
     data => { this.billing_tasks = data;
      let res = data[0];
      // create insert model
  this.model = {
    subject_id: this.subject_id,
    job_id: this.job_id,
    billing_task_name: this.subject_number + ' - ' + res.billing_task_name + ': ' + this.job_type_name + ' ' + this.job_type_location_name
     + ' ' + this.job_type_court_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_description: res.billing_task_description,
billing_task_fee: res.billing_task_fee,
billing_task_id: res.billing_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
  };


// :: make up the item
// let tax_percent;
// let tax_value = 0;
//  if(res.myob_tax_code_id == 1) {
//    tax_percent = 10;
//    tax_value = (res.billing_task_fee / (100 / tax_percent));
//  }
//  if(res.myob_tax_code_id == 2) {
//    tax_percent = 0;
//    tax_value = 0;
//  }

  // this.invoiceItemsList2 = {
  //   invoice_number: this.invoice_number,
  //   invoice_id: this.invoice_id,
  //   billing_task_id: res.billing_task_id,
  //   subject_billing_item_id: res.subject_billing_item_id,  // need to ge this to fix !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //   billing_task_name: res.billing_task_name,
  //   myob_tax_code_id: res.myob_tax_code_id,
  //   myob_account_code_id: res.myob_account_code_id,
  //   billing_task_fee: res.billing_task_fee,
  //   billing_task_description: res.billing_task_description,
  //   subject_id: this.subject_id,
  //   subject_number: this.subject_number,
  //   job_id: this.job_id,
  //   job_number: this.job_number,
  //   qty: 1,
  //   unit_price: res.billing_task_fee,
  //   tax: tax_value,
  //   total: res.billing_task_fee,
  //         };

  this.addSubjectBillingItemFromInvoiceUpdate(this.model);


     // TOD:::
// :: Add for Update to insert subjectBillingItems into invoiceItems.
   // :: add the items
//   this.addSubjectInvoiceItem(this.invoiceItemsList2, this.invoice_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database

  //  setTimeout( () => {  }, 0 );


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 addSubjectBillingItemFromInvoiceUpdate(model) {
  this._demoService.addSubjectBillingItem(model).subscribe(
     data => { this.new_subject_billing_item_id = data;
   //  let res = data[0];

              // Run the insert of insert objects through a loop.
       this.returned_subject_billing_item_id = this.new_subject_billing_item_id.last_insert_id;
       console.log('Returned BID: ' + this.returned_subject_billing_item_id);
      this.toastr.success('Billing Item Added');


// :: make up the item
let tax_percent;
let tax_value = 0;
 if(model.myob_tax_code_id == 1) {
   tax_percent = 10;
   tax_value = (model.billing_task_fee / (100 / tax_percent));
 }
 if(model.myob_tax_code_id == 2) {
   tax_percent = 0;
   tax_value = 0;
 }


      // now add the invoice items
  this.invoiceItemsList2 = {
    invoice_number: this.invoice_number,
    invoice_id: this.invoice_id,
    billing_task_id: model.billing_task_id,
    subject_billing_item_id: this.returned_subject_billing_item_id,
    billing_task_name: model.billing_task_name,
    myob_tax_code_id: model.myob_tax_code_id,
    myob_account_code_id: model.myob_account_code_id,
    billing_task_fee: model.billing_task_fee,
    billing_task_description: model.billing_task_description,
    subject_id: this.subject_id,
    subject_number: this.subject_number,
    job_id: this.job_id,
    job_number: this.job_number,
    qty: 1,
    unit_price: model.billing_task_fee,
    tax: tax_value,
    total: model.billing_task_fee,
    brand_id: this.brand_id,
          };
 this.addSubjectInvoiceItem(this.invoiceItemsList2, this.invoice_id);


  setTimeout( () => { }, 1500 );

    this.refreshInvoiceItemsBelow.emit(); // refreshed invoice list in below window. from modal template component.
      // :: now hide the invoice modal;
      this.closeParentModel2.emit();
     this.refreshSujectInvoicePage.emit(this.subject_id); // so refresh entire page instead.

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 


 addSubjectInvoiceItem(model, invoice_id){
  this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
    data => {  this.new_invoice_item_id = data; // this is the retuned json upon creation.
      // let res = data[0];
                      // Run the insert of insert objects through a loop.
                      this.returned_invoice_item_id = this.new_invoice_item_id.last_insert_id;
                      console.log('Returned IIID: ' + this.returned_invoice_item_id);

        let invoice_status = 'INVOICED';
        // tslint:disable-next-line:max-line-length
        this.updateSubjectBillingItemInvoiceStatus(invoice_status, this.returned_subject_billing_item_id, this.invoice_id, this.invoice_number, model);
        this.toastr.success('Invoice Item Added');
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }

// :: 
 updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model) {
  this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }







}